import { Injectable, EventEmitter } from '@angular/core';
import { IEvent, IImage } from '../interfaces/definitions';
@Injectable()
export class UploaderService {
  public photoSelector: EventEmitter<any> = new EventEmitter();
  public events: EventEmitter<IEvent> = new EventEmitter();

  public selectImage(image: IImage, images: IImage[]): IImage[] {
    return images.map((x: IImage) => {
      if (x.id === image.id) {
        x.$selected = true;
      } else {
        x.$selected = false;
      }
      return x;
    });
  }
  public multipleSelectImage(image: IImage, images: IImage[]): IImage[] {
    return images.map((x: IImage) => {
      if (x.id === image.id && x.$selected) {
        x.$selected = false;
      } else if (x.id === image.id) {
        x.$selected = true;
      }
      return x;
    });
  }
}
